import * as React from 'react';
import Box from '@mui/material/Box';
import { Row, Column } from 'simple-flexbox';
import { Grid, TextField, Paper, Typography } from '@mui/material';
import CustomDatePicker from '../../components/datePicker/datePicker2';

import AddButton from '../../components/button/addButton.js';
import { PaymentOffersTable } from './paymentOfferTableView.js';
import { apiBaseUrl } from '../../constant/endpoint.js';
import { axiosRequest } from '../../utility/axios.js';
import { useDispatch, useSelector } from 'react-redux';
import { EntryList, GAME_MODE, statusList } from '../../constant/constant.js';
import { useState, useEffect } from 'react';
import { setLoader } from '../../slices/loginSlice.js';
import AddContest from './add.js';
import CustomizedButtons from '../../components/button/button.js';
import SelectTextFields from '../../components/customDropDown/dropDown.js';
import { useNavigate } from "react-router-dom";

const defaultDateTimeState = {
    date_from: '',
    date_to: '',
}

export default function PaymentOffers() {
    const [searchData, setSearchData] = useState({});
    const [contestList, setContestList] = useState([]);

    const [dateTime, setDateTime] = useState(defaultDateTimeState);

    const [pagination, setPagination] = useState({
        currentPage: 1,
        nextPage: null,
        prevPage: null,
        totalPage: 1,
        size: 20,
    });

    const loginSlice = useSelector(state => state.loginSlice);
    const token = loginSlice.token;
    const dispatch = useDispatch();
    const navigate = useNavigate()

    

    const getPaymentOffersList = async (searchUrl, page = 1, size = 20) => {
        let url = `/paymentOffer/list`;
        let bodyData = { page: page, size: size };
        const resContest = await axiosRequest("POST", url, token, bodyData);
        if (resContest?.status === "success") {
            setContestList(resContest.data.paymentOffersList);
            setPagination(resContest.data.paginationData);
        }
    }

    const handleReset = () => {
        setSearchData({});
        getPaymentOffersList();
        setDateTime(defaultDateTimeState);
    };

    const handleAddPaymentOffer = () => {
        navigate('/payment-offer/add');
    };

    const handleSearch = async () => {
        let searchUrl = `/paymentOffer/list`;
        let postData = searchData;
        const res = await axiosRequest("POST", searchUrl, token, postData);

        if (res?.status == "success") {
            setContestList(res.data.paymentOffersList);
            setPagination(res.data.paginationData);
        }
        // getPaymentOffersList(searchUrl)
    }

    const handelChange = (e) => {
        let { name, value } = e.target;
        if (value !== '') {
            value = value.toUpperCase().replace(/[^\w\d]/g, "");
            if( value.length <= 8){
                setSearchData((prevState) => ({
                    ...prevState,
                    [name]: value
                }));
            }
           
        } else {
            const updatedSearchData = { ...searchData };
            delete updatedSearchData[name];
            setSearchData(updatedSearchData);
        }
    };

    const setDate = (date, key) => {
        setSearchData((prevState) => ({
            ...prevState,
            [key]: date
        }));
    };

    useEffect(() => {
        getPaymentOffersList();
    }, []);

    return (
        
        <Box sx={{ width: '100%', typography: 'body1' }} style={{ marginTop: "130px", textAlign: "center" }}>

        {/* Header Section */}
        <Grid container justifyContent='flex-end' >
            
            <AddButton onClick={handleAddPaymentOffer} name="Add Offer" />
        </Grid>

        {/* Filters Section */}
        <Box sx={{ padding: 3, marginBottom: 3 }}>
            <Grid container spacing={3} alignItems="center">
                <Grid item lg={3} md={6} xs={12}>
                    <CustomDatePicker
                        label={"Date Expire From"}
                        value={searchData?.date_from}
                        name={'date_from'}
                        handleOnChange={(date) => setDate(date, 'date_from')}
                    />
                </Grid>
                <Grid item lg={3} md={6} xs={12}>
                    <CustomDatePicker
                        label={"Date Expire To"}
                        value={searchData?.date_to}
                        name={'date_to'}
                        handleOnChange={(date) => setDate(date, 'date_to')}
                        minDate = {searchData?.date_from}
                        disabled = {!searchData?.date_from}
                    />
                </Grid>
                <Grid item lg={3} md={6} xs={12}>
                    <TextField
                        type="text"
                        sx={{ width: "100%", marginTop: "10px" }}
                        size="small"
                        variant="outlined"
                        name="coupon_code"
                        label="Coupon Code"
                        value={searchData?.coupon_code || ''}
                        onChange={handelChange}
                        onKeyPress={(e) => {
                            console.log("e",e);
                            if (e.key === "Enter") {
                                handleSearch();
                            }
                        }}
                        
                    />
                </Grid>
                <Grid item lg={3} md={6} xs={12} display="flex" justifyContent="flex-start" gap={2}>


                    <CustomizedButtons color="success" label="Search" onClick={handleSearch} />
                    <CustomizedButtons color="error" label="Reset" onClick={handleReset} />
                </Grid>
            </Grid>
        </Box>

        {/* Table Section */}
        <Box>
            {contestList && contestList.length ? (
                <PaymentOffersTable contestList={contestList} pagination={pagination} searchData={searchData}/>
            ) : (
                <Typography variant="body1" color="textSecondary" textAlign="center">
                    No offers available.
                </Typography>
            )}
        </Box>
    </Box>
    );
}
